import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@material-ui/core';
import Button from '../Button';
import { FormattedMessage } from 'react-intl';
import { Divider } from '@material-ui/core';

class SubscriptionGreeting extends Component {
  componentDidMount() {
    this.props.loadData();
  }
  render() {
    const {
      subscription,
      open,
      handleClose,
      handleGetStarted,
    } = this.props;

    const isWithoutTrialPeriod = subscription && subscription.plan && !subscription.plan.trialDuration ;

    return (
      <Dialog open={open}>
        <DialogTitle>
          <FormattedMessage 
            id={isWithoutTrialPeriod ? 'subscription.greeting.title.withoutTrial' : 'subscription.greeting.title.default' } 
            values={{
              planName: subscription && subscription.plan && subscription.plan.name
            }} 
          />
        </DialogTitle>        
        <DialogContent>
          <FormattedMessage 
            id={isWithoutTrialPeriod ? 'subscription.greeting.content.withoutTrial' : 'subscription.greeting.content.default' }
            values={{
              productName: subscription && subscription.plan 
                && subscription.plan.product && subscription.plan.product.name
            }}
          /> 
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={handleGetStarted} variant="contained">
            <FormattedMessage id='subscription.greeting.getStarted.button' /> 
          </Button>
          <Button onClick={handleClose}>
            <FormattedMessage id='subscription.greeting.myAccount.button' /> 
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

SubscriptionGreeting.propTypes = {
  subscription: PropTypes.object.isRequired,
  loadData: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleGetStarted: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default SubscriptionGreeting;


// WEBPACK FOOTER //
// ./src/components/subscriptions/SubscriptionGreeting.js